export default __webpack_public_path__ + "static/media/thumb003.d856c3eb.png";